// import React, {
//   useEffect,
//   useState,
//   forwardRef,
//   useImperativeHandle,
// } from "react";
// import html2pdf from "html2pdf.js";

// const EstimateDownloadPDF = forwardRef(
//   ({ property, estimateData, headerImage, footerImage, approveImage }, ref) => {
//     const [currentDate, setCurrentDate] = useState("");

//     useEffect(() => {
//       const today = new Date();
//       const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
//         today.getMonth() + 1
//       )
//         .toString()
//         .padStart(2, "0")}/${today.getFullYear()}`;
//       setCurrentDate(formattedDate);
//     }, []);

   
//     useImperativeHandle(ref, () => ({
//       generatePDF: () => {
//         generatePDF();
//       },
//     }));

//     const generatePDF = () => {
//       const element = document.getElementById("estimate-pdf-content");

//       if (!element) {
//         console.error("PDF content element not found");
//         return;
//       }

//       element.classList.remove("hidden");

//       const today = new Date();
//       const formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(
//         today.getMonth() + 1
//       )
//         .toString()
//         .padStart(2, "0")}-${today.getFullYear()}`;

//       const options = {
//         filename: `${formattedDate} ${estimateData?.propertyName} Plot No ${estimateData?.plotNo} Estimate.pdf`,
//         image: { type: "png", quality: 1.0 },
//         html2canvas: { scale: 2, useCORS: true },
//         jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//       };

//       html2pdf()
//         .from(element)
//         .set(options)
//         .save()
//         .then(() => {
//           element.classList.add("hidden");
//         })
//         .catch((err) => {
//           console.error("Error generating PDF:", err);
//           element.classList.add("hidden");
//         });
//     };

//     return (
//       <div>
//         <div
//           id="estimate-pdf-content"
//           className="hidden bg-white w-[794px] h-[1020px] p-8"
//         >
//           <div>
//             <img src={headerImage} alt="Header" />
//           </div>

//           <div className="mx-8">
//             {/* Title */}
//             <div className="flex items-center justify-between mt-2 pb-2">
//               <div className="text-start font-inter text-[#2E6D92] text-4xl font-semibold">
//                 Property Estimate
//               </div>
//               <div className="text-base">
//                 Estimate ID: {estimateData?.estimateId || "EST001"}
//               </div>
//             </div>

//             <div className="flex items-center justify-between mt-5">
//               <div className="flex flex-col gap-1">
//                 <div className="text-base font-semibold">
//                   {estimateData?.propertyName || "Unknown"}
//                 </div>
//                 <div className="text-base">
//                   Plot No {estimateData?.plotNo || "N/A"},{" "}
//                   {estimateData?.totalPlotSqft || "0"} SQ Feet
//                 </div>
//               </div>
//               <div className="flex flex-col gap-1">
//                 <div className="text-base">Created On: {currentDate}</div>
//                 <div className="text-base">
//                   Created By: {estimateData?.createdByEmployeeId || "Unknown"}
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center justify-start mt-5">
//               <div className="flex flex-col gap-1">
//                 <div className="text-base">
//                   Per Sq Feet Price: ₹
//                   {estimateData?.plotPerSqftPrice?.toLocaleString("en-IN") ||
//                     "0"}
//                 </div>
//                 <div className="text-base">
//                   Guideline Value: ₹
//                   {estimateData?.guidelineValue?.toLocaleString("en-IN") || "0"}
//                 </div>
//               </div>
//             </div>

//             <div className="mt-8">
//               <table className="w-full border-collapse border">
//                 <tbody>
//                   <tr>
//                     <td
//                       colSpan="2"
//                       className="border border-gray-300 p-2 text-center font-semibold text-lg"
//                     >
//                       Price Detail
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="border border-gray-300 p-2 pl-4 w-1/2">
//                       <div>Actual Price</div>
//                       <div>
//                         ({estimateData?.totalPlotSqft || "0"} x{" "}
//                         {estimateData?.plotPerSqftPrice || "00"})
//                       </div>
//                     </td>
//                     <td className="border border-gray-300 p-2 pl-4 text-right">
//                       ₹
//                       {estimateData?.actualAmount?.toLocaleString("en-IN") ||
//                         "0"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="border border-gray-300 p-2 pl-4">
//                       Registration Charge
//                       <div>
//                         ({estimateData?.totalPlotSqft || "840"} x{" "}
//                         {estimateData?.guidelineValue || "2530"} x 9%)
//                       </div>
//                     </td>
//                     <td className="border border-gray-300 p-2 pl-4 text-right">
//                       ₹
//                       {estimateData?.registrationCharge?.toLocaleString(
//                         "en-IN"
//                       ) || "0"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="border border-gray-300 p-2 pl-4">
//                       Document Charge
//                     </td>
//                     <td className="border border-gray-300 p-2 pl-4 text-right">
//                       ₹
//                       {estimateData?.documentCharge?.toLocaleString("en-IN") ||
//                         "0"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="border border-gray-300 p-2 pl-4 font-semibold">
//                       Total Price
//                     </td>
//                     <td className="border border-gray-300 p-2 pl-4 text-right font-semibold">
//                       ₹
//                       {estimateData?.totalAmount?.toLocaleString("en-IN") ||
//                         "0"}
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             {estimateData?.loanPercentage > 0 && (
//               <div className="mt-10">
//                 <table className="w-full border-collapse border">
//                   <tbody>
//                     <tr>
//                       <td
//                         colSpan="2"
//                         className="border border-gray-300 p-2 text-center font-semibold text-lg"
//                       >
//                         Loan Details
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="border border-gray-300 p-2 pl-4 w-1/2">
//                         <div>Loan {estimateData?.loanPercentage || "0"}%</div>
//                         <div>
//                           ({estimateData?.totalPlotSqft || "0"} x{" "}
//                           {estimateData?.plotPerSqftPrice || "00"} x{" "}
//                           {estimateData?.loanPercentage || "90"}%)
//                         </div>
//                       </td>
//                       <td className="border border-gray-300 p-2 pl-4 text-right">
//                         ₹
//                         {estimateData?.loanAmount?.toLocaleString("en-IN") ||
//                           "0"}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="border border-gray-300 p-2 pl-4 font-semibold">
//                         Down Payment
//                       </td>
//                       <td className="border border-gray-300 p-2 pl-4 text-right font-semibold">
//                         ₹
//                         {estimateData?.downPayment?.toLocaleString("en-IN") ||
//                           "0"}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             <div className="flex items-center justify-between mt-8">
//               <div className="text-base">
//                 Estimate Valid Till -{" "}
//                 {estimateData?.validity
//                   ? new Date(estimateData.validity).toLocaleDateString("en-IN")
//                   : "N/A"}
//               </div>
//               <div className="absolute right-6  ">
//                 <img src={approveImage} alt="Approved" className="h-40" />
//               </div>
//             </div>
//           </div>

//           <div className="absolute bottom-0 left-0 right-0">
//             <img src={footerImage} alt="Footer" />
//           </div>
//         </div>
//       </div>
//     );
//   }
// );

// export default EstimateDownloadPDF;



import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import html2pdf from "html2pdf.js";

const EstimateDownloadPDF = forwardRef(
  ({ estimateData }, ref) => {
    const [currentDate, setCurrentDate] = useState("");

    useEffect(() => {
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
        today.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}/${today.getFullYear()}`;
      setCurrentDate(formattedDate);
    }, []);

    useImperativeHandle(ref, () => ({
      generatePDF: () => {
        generatePDF();
      },
    }));

    const generatePDF = () => {
      const element = document.getElementById("estimate-pdf-content");

      if (!element) {
        console.error("PDF content element not found");
        return;
      }

      element.classList.remove("hidden");

      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, "0")}-${(
        today.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${today.getFullYear()}`;

      const options = {
        filename: `${formattedDate} Estimate.pdf`,
        image: { type: "png", quality: 1.0 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .from(element)
        .set(options)
        .save()
        .then(() => {
          element.classList.add("hidden");
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
          element.classList.add("hidden");
        });
    };

    return (
      <div>
        <div
          id="" className="hidden bg-white"
        >
          {estimateData && (
            <div className="">
              <div dangerouslySetInnerHTML={{ __html: estimateData }} />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default EstimateDownloadPDF;

